import { Role } from "types";
import { User } from "auth/AuthProvider";

export const mockUsers: User[] = [
  {
    id: "u1",
    name: "Alice Smith",
    email: "alice@example.com",
    current_workspace: {
      id: "w1",
      name: "Workspace 1",
      organization_name: "Acme Corp",
    },
    workspaces: [
      { id: "w1", name: "Workspace 1", organization_name: "Acme Corp" },
      { id: "w2", name: "Workspace 2", organization_name: "Acme Corp" },
    ],
    current_organization: { id: "o1", name: "Org 1" },
    organizations: [
      { id: "o1", name: "Org 1" },
      { id: "o2", name: "Org 2" },
    ],
  },
  {
    id: "u2",
    name: "Bob Johnson",
    email: "bob@example.com",
    current_workspace: {
      id: "w1",
      name: "Workspace 1",
      organization_name: "Acme Corp",
    },
    workspaces: [
      { id: "w1", name: "Workspace 1", organization_name: "Acme Corp" },
      { id: "w2", name: "Workspace 2", organization_name: "Acme Corp" },
    ],
    current_organization: { id: "o1", name: "Org 1" },
    organizations: [
      { id: "o1", name: "Org 1" },
      { id: "o2", name: "Org 2" },
    ],
  },
  {
    id: "u3",
    name: "Charlie Lee",
    email: "charlie@example.com",
    current_workspace: {
      id: "w2",
      name: "Workspace 2",
      organization_name: "Acme Corp",
    },
    workspaces: [
      { id: "w1", name: "Workspace 1", organization_name: "Acme Corp" },
      { id: "w2", name: "Workspace 2", organization_name: "Acme Corp" },
    ],
    current_organization: { id: "o2", name: "Org 2" },
    organizations: [
      { id: "o1", name: "Org 1" },
      { id: "o2", name: "Org 2" },
    ],
  },
  {
    id: "u4",
    name: "Diana Prince",
    email: "diana@example.com",
    current_workspace: {
      id: "w2",
      name: "Workspace 2",
      organization_name: "Acme Corp",
    },
    workspaces: [
      { id: "w1", name: "Workspace 1", organization_name: "Acme Corp" },
      { id: "w2", name: "Workspace 2", organization_name: "Acme Corp" },
    ],
    current_organization: { id: "o2", name: "Org 2" },
    organizations: [
      { id: "o1", name: "Org 1" },
      { id: "o2", name: "Org 2" },
    ],
  },
  {
    id: "u5",
    name: "Eve Adams",
    email: "eve@example.com",
    current_workspace: {
      id: "w1",
      name: "Workspace 1",
      organization_name: "Acme Corp",
    },
    workspaces: [
      { id: "w1", name: "Workspace 1", organization_name: "Acme Corp" },
      { id: "w2", name: "Workspace 2", organization_name: "Acme Corp" },
    ],
    current_organization: { id: "o1", name: "Org 1" },
    organizations: [
      { id: "o1", name: "Org 1" },
      { id: "o2", name: "Org 2" },
    ],
  },
  {
    id: "u6",
    name: "Frank Miller",
    email: "frank@example.com",
    current_workspace: {
      id: "w2",
      name: "Workspace 2",
      organization_name: "Acme Corp",
    },
    workspaces: [
      { id: "w1", name: "Workspace 1", organization_name: "Acme Corp" },
      { id: "w2", name: "Workspace 2", organization_name: "Acme Corp" },
    ],
    current_organization: { id: "o2", name: "Org 2" },
    organizations: [
      { id: "o1", name: "Org 1" },
      { id: "o2", name: "Org 2" },
    ],
  },
  {
    id: "u7",
    name: "Grace Hopper",
    email: "grace@example.com",
    current_workspace: {
      id: "w1",
      name: "Workspace 1",
      organization_name: "Acme Corp",
    },
    workspaces: [
      { id: "w1", name: "Workspace 1", organization_name: "Acme Corp" },
      { id: "w2", name: "Workspace 2", organization_name: "Acme Corp" },
    ],
    current_organization: { id: "o1", name: "Org 1" },
    organizations: [
      { id: "o1", name: "Org 1" },
      { id: "o2", name: "Org 2" },
    ],
  },
];

export const mockRoles: Role[] = [
  {
    id: "r1",
    name: "Admins",
    description: "Administrators of the system",
    members: [
      mockUsers[0],
      mockUsers[1],
      mockUsers[2],
      mockUsers[3],
      mockUsers[4],
    ],
    createdAt: "2024-01-01T10:00:00Z",
    updatedAt: "2024-01-10T12:00:00Z",
    is_active: true,
    total_members: 0,
    workspace_id: "1",
  },
  // {
  //   id: "r2",
  //   name: "Editor",
  //   description: "Can edit content and manage resources",
  //   members: [
  //     mockUsers[2],
  //     mockUsers[3],
  //   ],
  //   createdAt: "2024-01-02T10:00:00Z",
  //   updatedAt: "2024-01-11T12:00:00Z",
  //   is_active: true,
  //   total_members: 0,
  //   workspace_id: "1",
  // },
  // {
  //   id: "r3",
  //   name: "Viewer",
  //   description: "Read-only access to resources",
  //   members: [
  //     mockUsers[4],
  //     mockUsers[5],
  //     mockUsers[6],
  //   ],
  //   createdAt: "2024-01-03T10:00:00Z",
  //   updatedAt: "2024-01-12T12:00:00Z",
  //   is_active: true,
  //   total_members: 0,
  //   workspace_id: "1",
  // },
];
